import { render, staticRenderFns } from "./SetupSSO.vue?vue&type=template&id=6c47f62f&"
import script from "./SetupSSO.vue?vue&type=script&lang=js&"
export * from "./SetupSSO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c47f62f')) {
      api.createRecord('6c47f62f', component.options)
    } else {
      api.reload('6c47f62f', component.options)
    }
    module.hot.accept("./SetupSSO.vue?vue&type=template&id=6c47f62f&", function () {
      api.rerender('6c47f62f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Components/SetupSSO/SetupSSO.vue"
export default component.exports